import React, { useEffect } from 'react';
import Hero from '../../components/Hero';
import TrendingMovies from '../../components/TrendingMovies';
import HowItWorks from '../../components/HowItWorks';
import CTA from '../../components/CTA';
import './Home.css';

const Home: React.FC = () => {
  // Scroll reveal animation
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="unified-space-wrapper">
      {/* Single unified depth background for entire page */}
      <div className="unified-depth-bg">
        <div className="unified-depth-layer unified-layer-void"></div>
        <div className="unified-depth-layer unified-layer-nebula"></div>
        <div className="unified-depth-layer unified-layer-stars"></div>
      </div>

      <Hero />
      <TrendingMovies />
      <HowItWorks />
      <CTA />
    </div>
  );
};

export default Home;
